/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    AvalancheWinInfo,
    BetLineWinData,
    KitchenDramaSushiManiaGameData,
    KitchenDramaSushiManiaInitData, SymbolValues
} from "./KitchenDramaSushiManiaData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {KitchenDramaSushiManiaGameMode} from "./KitchenDramaSushiManiaGameMode";

export class KitchenDramaSushiManiaModel extends GameModel<KitchenDramaSushiManiaInitData, KitchenDramaSushiManiaGameData> {
    public isRestore:boolean = false;
    public betLines:number[][];
    public symbolValues?:SymbolValues;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
    }

    protected onInit(data:KitchenDramaSushiManiaInitData):void {
        super.onInit(data);
        this.betLines = data.betLines;
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
    }

    protected onGame(data:KitchenDramaSushiManiaGameData):void {
        super.onGame(data);
        this.isRestore = false;

        if (data.mode === KitchenDramaSushiManiaGameMode.WILD_SUSHI){
            data.reels = this.swapFsWilds(data.reels);
        }
        this.calculateAccumulatedWins(data);
    }

    private calculateAccumulatedWins(data:KitchenDramaSushiManiaGameData) {
        for (let i:number = 0; i < data.avalancheWinInfo.length; i++){
            const winInfo:AvalancheWinInfo =  data.avalancheWinInfo[i];
            winInfo.clientAccumulatedWin = 0;

            if (i == 0){
                winInfo.clientAccumulatedWin = data.accumulatedWinBeforeSpin;
            }
            winInfo.clientAccumulatedWin += winInfo.avalancheWin;
            if (i > 0){
                winInfo.clientAccumulatedWin += data.avalancheWinInfo[i-1].clientAccumulatedWin!;
            }
        }

    }

    private swapFsWilds(reels:string[][][]):string[][][] {
        for (let round of reels){
            for (let reelSet of round){
                for (let i:number = 0; i < reelSet.length; i++){
                    if (reelSet[i] === "W"){
                        reelSet[i] = "W3";
                    }
                }
            }
        }

        return reels;
    }

    public createWinMatrix(winLines:BetLineWinData[]):StateMatrix<KitchenDramaSushiManiaSymbolStates> {
        const matrix = new StateMatrix<KitchenDramaSushiManiaSymbolStates>();
        matrix.initWithValue(5, 3, KitchenDramaSushiManiaSymbolStates.NO_WIN);

        for (let win of winLines) {
            let lineData = this.betLines[win.betLine].concat();
            lineData = lineData.slice(0, win.nrOfSymbols);

            for (let reelIndex = 0; reelIndex < lineData.length; reelIndex++){
                matrix.matrix[reelIndex][lineData[reelIndex]] = KitchenDramaSushiManiaSymbolStates.WIN;
            }

        }

        return matrix;
    }


}